import pathfinder from '@fiverr-private/pathfinder';
import { PATHFINDER, formatQueryParams } from '../../utils';
import type { MapperItemConfig } from './types';

export const getStorePath = ({ slug = '', queryParams, source }: MapperItemConfig) => {
    const params = { store_name: slug };
    return pathfinder(PATHFINDER.STORE, params, formatQueryParams({ queryParams, source }));
};
